export default Object.freeze ({
  ACCION: {
    CREATE: "C",
    READ: "R",
    UPDATE: "U",
    DELETE: "D"
  }
});